export const addictionCardTextBoldDesktop = () => ({
    fontFamily:"Candal",
    color:"#EEEEEE",
    fontSize: "clamp(15px, 1.25vw, 25px)",
});
export const addictionCardTextNormalDesktop = () => ({
    color:"#EEEEEE",
    fontSize: "clamp(15px, 1.25vw, 25px)",
});
export const addictionCardTagLineBoldDesktop = () => ({
    fontFamily:"Candal",
    color:"#EEEEEE",
    fontSize: "clamp(12px, 1.15vw, 20px)",
});
export const addictionCardTagLineNormalDesktop = () => ({
    color:"#bebebe",
    fontSize: "clamp(12px, 1.15vw, 20px)",
});


export const addictionCardTextBoldMobile = () => ({
    fontFamily:"Candal",
    color:"#EEEEEE",
    fontSize: "clamp(15px, 2vh, 25px)",
});
export const addictionCardTextNormalMobile = () => ({
    color:"#EEEEEE",
    fontSize: "clamp(15px, 2vh, 25px)",
});

export const addictionCardTagLineBoldMobile = () => ({
    fontFamily:"Candal",
    color:"#EEEEEE",
    fontSize: "clamp(15px, 2vh, 25px)",
});

export const addictionCardTagLineNormalMobile = () => ({
    color:"#bebebe",
    fontSize: "clamp(11px, 1.15vh, 15px)",
});

export const moneyContainerHeadingBoldMobile = () => ({
    fontFamily:"Outfit",
    color:"#EEEEEE",
    fontSize: "clamp(10px, 1.75vh, 15px)",
    fontWeight:"900"
});

export const moneyContainerHeadingBoldDesktop = () => ({
    fontFamily:"Candal",
    color:"#EEEEEE",
    fontSize: "clamp(10px, 1.65vw, 15px)",
});

export const penaltyTextDesktop = () => ({
    fontFamily:"Candal",
    color:"#EEEEEE",
    fontSize: "clamp(32px, 2.75vw, 40px)",
});
export const penaltyTextMobile = () => ({
    fontFamily:"Candal",
    color:"#EEEEEE",
    fontSize:"clamp(20px,1.65vh,25px)"
});

export const smallestFontDesktop = () => ({
    fontSize:"clamp(11px,1vw,13px)"
});

export const smallestFontMobile = () => ({
    fontSize:"clamp(7px,1.25vh,8px)"
});

export const tinyFontMobile = () => ({
    fontSize:"clamp(10px,1vh,12px)",
    fontWeight:900
});


